var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"secondary-page"},[_c('h1',{staticClass:"page-title"},[_vm._v(_vm._s(_vm.getPage.title))]),(!_vm.loading)?[_c('WagtailContent',{attrs:{"api_content":_vm.getPage}})]:_c('div',{staticClass:"loader"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }